'use client'
import React, { useState } from 'react'
import { useSession } from 'next-auth/react'
import {
    CHeader,
    CContainer,
    CHeaderNav,
    CNavItem,
    CRow,
    CCol,
    CButton,
} from '@coreui/react'

import CIcon from '@coreui/icons-react'
import { cilBell } from '@coreui/icons'
import LogoutButton from './LogoutButton'
import BusquedaBasicaHeader from './BusquedaBasicaHeader'

export default function Header() {
    const { data: session } = useSession()
    const [mostrarCerrarSesion, setMostrarCerrarSesion] = useState(false)
    const notificacionesSinLeer = 6

    const nombreUsuario = session?.user?.name || session?.user?.email || 'Usuario'
    const fuenteIniciales = session?.user?.name || session?.user?.email || ''
    const partesNombre = fuenteIniciales.trim().split(/\s+/).filter(Boolean)
    const iniciales = (partesNombre.length > 1
        ? `${partesNombre[0][0]}${partesNombre[partesNombre.length - 1][0]}`
        : partesNombre[0]?.slice(0, 2) || 'U'
    ).toLocaleUpperCase('es-MX')

    return (
        <CHeader className="p-0 border-bottom bg-white shadow-sm flex-column align-items-stretch">

            {/* SECCIÓN SUPERIOR: EL BANNER INSTITUCIONAL DE TU IMAGEN */}
            <div className="container-fluid py-2">
                <CContainer fluid className="px-2">
                    <CRow className="align-items-center g-3">

                        <CCol xs={12} md={6} className="d-flex align-items-center justify-content-center justify-content-md-start gap-3 text-center text-md-start">
                            <img
                                src="/images/logo-unam.png"
                                alt="Logo UNAM"
                                style={{ height: '55px', width: 'auto', objectFit: 'contain' }}
                            />
                            <img
                                src="/images/logo-hnm.png"
                                alt="Hemeroteca Nacional de México"
                                style={{ height: '50px', width: 'auto', objectFit: 'contain' }}
                            />
                            <div>
                                <h1 className="m-0 text-dark fw-bold" style={{ fontFamily: 'serif', fontSize: '28px', letterSpacing: '0.5px' }}>
                                    Hemerográfica
                                </h1>
                                <div className="text-secondary fst-italic small mt-1" style={{ fontSize: '13px' }}>
                                    Plataforma de sistematización de la prensa mexicana
                                </div>
                            </div>
                        </CCol>

                        <CCol xs={12} md={6} className="d-flex justify-content-center justify-content-md-end">
                            <CHeaderNav className="d-flex flex-wrap align-items-center justify-content-center justify-content-md-end gap-3">
                                <CNavItem className="position-relative">
                                    <CButton
                                        variant="ghost"
                                        color="secondary"
                                        className="p-1 border-0 rounded-circle position-relative"
                                        style={{ width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                        onClick={() => alert('Próximamente: Historial de capturas y análisis')}
                                        aria-label={`${notificacionesSinLeer} notificaciones sin leer`}
                                    >
                                        <CIcon icon={cilBell} size="lg" className="text-dark" />
                                        {notificacionesSinLeer > 0 && (
                                            <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                                                {notificacionesSinLeer}
                                            </span>
                                        )}
                                    </CButton>
                                </CNavItem>

                                {session?.user && (
                                    <div className="position-relative d-flex align-items-center gap-2 ms-1">
                                        {session.user.image ? (
                                            <img
                                                src={session.user.image}
                                                alt={`Foto de perfil de ${nombreUsuario}`}
                                                className="rounded-circle flex-shrink-0"
                                                style={{ width: '36px', height: '36px', objectFit: 'cover' }}
                                            />
                                        ) : (
                                            <span
                                                className="rounded-circle flex-shrink-0 d-flex align-items-center justify-content-center bg-primary text-white fw-semibold"
                                                style={{ width: '36px', height: '36px', fontSize: '13px' }}
                                                role="img"
                                                aria-label={`Iniciales de ${nombreUsuario}`}
                                            >
                                                {iniciales}
                                            </span>
                                        )}
                                        <div className="text-start d-none d-sm-block">
                                            <button
                                                type="button"
                                                className="border-0 bg-transparent p-0 text-start fw-semibold text-dark"
                                                style={{ fontSize: '12px', lineHeight: '1.2' }}
                                                aria-expanded={mostrarCerrarSesion}
                                                aria-controls="opcion-cerrar-sesion"
                                                onClick={() => setMostrarCerrarSesion((visible) => !visible)}
                                            >
                                                {nombreUsuario}
                                            </button>
                                            <div className="text-muted" style={{ fontSize: '10px' }}>
                                                {session.user.email || 'Sin correo'}
                                            </div>
                                        </div>
                                        {mostrarCerrarSesion && (
                                            <div
                                                id="opcion-cerrar-sesion"
                                                className="position-absolute end-0 top-100 z-3 mt-2 rounded border bg-white p-1 shadow"
                                            >
                                                <LogoutButton />
                                            </div>
                                        )}
                                    </div>
                                )}

                                <BusquedaBasicaHeader />
                            </CHeaderNav>
                        </CCol>
                    </CRow>
                </CContainer>
            </div>

        </CHeader>
    )
}
